import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { DtpContentContainer, DtpAccordionGroup, DtpAccordionPanel } from 'dtp-react-components';
import { Input, Button, Grid, Table } from '../../components';
import Masks from '../../utils/masks';
import { doGet, trataMensagensErro } from '../../utils/requests';

class Calculadora extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acrescimosLegaisPesquisa: {
        dataVencimento: null,
        dataPagamento: null,
        valorBaseCalculo: null,
      },
      listaAcrescimosLegaisResultado: [],
    };
  }

  handleChange = (changeObj, name, callback = null) => {
    const { acrescimosLegaisPesquisa } = { ...this.state };
    this.setState({
      acrescimosLegaisPesquisa: {
        ...acrescimosLegaisPesquisa,
        [name]: changeObj.value,
      },
    }, callback);
  }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
    if (retorno.indexOf('_') !== -1) {
      retorno = retorno.toString().replace('_', '');
    }
    retorno = retorno.toString().replace(/\D/g, '');
    retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
    e.target.value = retorno;

    return retorno;
  }

  habilitarBotao = () => {
    let valido = false;
    const { acrescimosLegaisPesquisa } = { ...this.state };
    if (acrescimosLegaisPesquisa.dataVencimento && acrescimosLegaisPesquisa.dataPagamento && acrescimosLegaisPesquisa.valorBaseCalculo) {
      valido = true;
    }

    return valido;
  }

  handleCalcular = () => {
    const { acrescimosLegaisPesquisa } = { ...this.state };
    if (acrescimosLegaisPesquisa.dataVencimento && acrescimosLegaisPesquisa.dataPagamento && acrescimosLegaisPesquisa.valorBaseCalculo) {
      const dataVencimento = acrescimosLegaisPesquisa.dataVencimento.replace(/\//g, '').replace(/_/g, '');
      const dataPagamento = acrescimosLegaisPesquisa.dataPagamento.replace(/\//g, '').replace(/_/g, '');
      const valorBaseCalculo = acrescimosLegaisPesquisa.valorBaseCalculo.replace(/\./g, '').replace(/,/g, '.');

      if (moment(dataPagamento, 'DD/MM/YYYY').toDate() < moment(dataVencimento, 'DD/MM/YYYY').toDate()) {
        trataMensagensErro(['A data de pagamento deve ser maior ou igual a data de vencimento.']);
      } else {
        const url = `acrescimos-legais/${dataVencimento}/${dataPagamento}/${valorBaseCalculo}`;
        doGet(url, this.trataSucessoResponse);
      }
    }
  }

  trataSucessoResponse = (response) => {
    if (response.data) {
      this.setState({ listaAcrescimosLegaisResultado: [response.data] });
    }
  }

  recuperarColunasDescritivoMulta = () => {
    const cabecalhoTabela = [{
      id: 'diasAtraso',
      label: 'Dias de Atraso',
    }, {
      id: 'multaPorDia',
      label: '% Multa (diária)',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'multaAcumulada',
      label: '% Multa (acumulada)',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalMulta',
      label: 'Valor Total Multa',
      dataFormat: this.formatarValor,
    }];

    return cabecalhoTabela;
  }

  recuperarColunasDescritivoJuroSelic = () => {
    const cabecalhoTabela = [{
      id: 'listaMeAnoSelicAcumulada',
      label: 'Meses Considerados',
      dataFormat: this.formatarMesesConsiderados,
    }, {
      id: 'selicAcumulada',
      label: '% Selic Acumulada',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalJuroSelicAcumulada',
      label: 'Valor Total da Selic Acumulada',
      dataFormat: this.formatarValor,
    }];

    return cabecalhoTabela;
  }

  recuperarColunasDescritivoJuroFixo = () => {
    const cabecalhoTabela = [{
      id: 'juroFixo',
      label: '% Juro Fixo',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalJuroFixo',
      label: 'Valor Total do Juro Fixo',
      dataFormat: this.formatarValor,
    }];

    return cabecalhoTabela;
  }

  recuperarColunasCalculoFinal = () => {
    const cabecalhoTabela = [{
      id: 'dataVencimento',
      label: 'Data de Vencimento',
      dataFormat: this.formatarData,
    }, {
      id: 'dataPagamento',
      label: 'Data de Pagamento',
      dataFormat: this.formatarData,
    }, {
      id: 'valorBaseCalculo',
      label: 'Valor Base de Cálculo',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalMulta',
      label: 'Valor Total da Multa',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalJuros',
      label: 'Valor Total de Juros',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalPagamento',
      label: 'Valor Total de Pagamento',
      dataFormat: this.formatarValor,
    }];

    return cabecalhoTabela;
  }

  formatarValor = (valor) => {
    let valorFormatado = '0.0';
    if (valor) {
      const formato = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
        style: 'currency',
        currency: 'BRL',
      };
      valorFormatado = valor.toLocaleString('pt-BR', formato);
    }
    return valorFormatado;
  };

  formatarPercentual = (valor) => {
    let valorFormatado = '0.0';
    if (valor) {
      const formato = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      };
      valorFormatado = valor.toLocaleString('pt-BR', formato);
    }
    return valorFormatado;
  };

  formatarMesesConsiderados = (lista) => {
    let listaMesesConsideradosFormatado = '--------';
    if (lista) {
      if (lista.length === 1) {
        listaMesesConsideradosFormatado = lista;
      } else {
        listaMesesConsideradosFormatado = lista[0].concat(' a ').concat(lista[lista.length - 1]);
      }
    }

    return listaMesesConsideradosFormatado;
  };

  formatarData = (data) => {
    let dataFormatada = '';
    if (data) {
      dataFormatada = moment(data).format('DD/MM/YYYY');
    }
    return dataFormatada;
  };

  render() {
    const options = {
      withoutNoDataText: true,
    };

    return (
      <DtpContentContainer>
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="calculo"
            panelId="calculo-acrescimos-legais"
            icon="ico-calc"
            title="Calculadora de Acréscimos Legais"
          >
            <div className="row">
              <Grid cols="3 3 3 3">
                <Input
                  mask={Masks.date}
                  label="Data de Vencimento"
                  required
                  onChange={e => this.handleChange(e, 'dataVencimento')}
                  value={this.state.acrescimosLegaisPesquisa.dataVencimento}
                />
              </Grid>
              <Grid cols="3 3 3 3">
                <Input
                  mask={Masks.date}
                  label="Data de Pagamento"
                  required
                  onChange={e => this.handleChange(e, 'dataPagamento')}
                  value={this.state.acrescimosLegaisPesquisa.dataPagamento}
                />
              </Grid>
              <Grid cols="3 3 3 3">
                <Input
                  currency
                  showMask={false}
                  label="Valor em Atraso"
                  maxLength="16"
                  required
                  value={this.state.acrescimosLegaisPesquisa.valorBaseCalculo}
                  onChange={e => this.handleChange(e, 'valorBaseCalculo')}
                  onKeyUp={e => this.handleKeyUp(e)}
                />
              </Grid>
              <Grid cols="3 3 3 3">
                <Button
                  className="dtp-primary"
                  disabled={!this.habilitarBotao()}
                  title="Calcular"
                  hint="Calcular Acréscimos Legais"
                  onClick={this.handleCalcular}
                />
              </Grid>
            </div>
          </DtpAccordionPanel>
        </DtpAccordionGroup>
        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <Table
            bordered
            legend="Descritivo do cálculo da multa"
            data={this.state.listaAcrescimosLegaisResultado !== null ? this.state.listaAcrescimosLegaisResultado : []}
            listaTableHeader={this.recuperarColunasDescritivoMulta()}
            options={options}
          />
        }

        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <Table
            bordered
            legend="Descritivo do cálculo do Juro Selic"
            data={this.state.listaAcrescimosLegaisResultado !== null ? this.state.listaAcrescimosLegaisResultado : []}
            listaTableHeader={this.recuperarColunasDescritivoJuroSelic()}
            options={options}
          />
        }

        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <Table
            bordered
            legend="Descritivo do cálculo do Juro Fixo"
            data={this.state.listaAcrescimosLegaisResultado !== null ? this.state.listaAcrescimosLegaisResultado : []}
            listaTableHeader={this.recuperarColunasDescritivoJuroFixo()}
            options={options}
          />
        }

        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <Table
            bordered
            legend="Cálculo Final"
            data={this.state.listaAcrescimosLegaisResultado !== null ? this.state.listaAcrescimosLegaisResultado : []}
            listaTableHeader={this.recuperarColunasCalculoFinal()}
            options={options}
          />
        }

        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <div className="rowFundamentacao">
            <br /><br />
            <b>Fundamentação legal</b><br /><br />
            {/* ib488652<b>I - Multa de Mora</b> - Art. 61 da Lei 9.430/1996 e Art. 35 da Lei nº 8.212/1991<br />
            Desde a competência dezembro de 2008 os débitos das contribuições sociais para com a União devem ser acrescidos de multa de mora calculada à
            taxa de 0,33, por dia de atraso, limitada a 20%. A multa é calculada a partir do primeiro dia subsequente ao do vencimento do prazo previsto
            para o pagamento da contribuição até o dia em que ocorrer o seu pagamento.
            <br /> */}
            <b>I - Multa de Mora</b> - Art. 70 da Portaria nº 1400/2024<br />
            A multa de mora não se aplica.
            <br />
          </div>
        }

        {(this.state.listaAcrescimosLegaisResultado !== null && this.state.listaAcrescimosLegaisResultado.length > 0) &&
          <div className="rowFundamentacao">
            <br /><br />
            <b>II - Juros de Mora</b> - Art. 35 da Lei nº 8.212/1991<br />
            Os juros de mora devem ser calculados à taxa do Sistema Especial de Liquidação e Custódia (SELIC), a partir do 1º dia do mês subsequente
            ao vencimento do prazo até o mês anterior ao do pagamento e de 1% no mês do pagamento.
          </div>
        }
      </DtpContentContainer>
    );
  }
}

Calculadora.propTypes = { };

export default connect()(Calculadora);



// WEBPACK FOOTER //
// ./src/pages/acrescimos-legais/Calculadora.jsx